import React from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../stores/auth";
import useAvatar from "./useAvatar";
import TrueOrFalseModal from "../true_or_false_modal";

const AvatarDropdown = () => {
    
    const baseUrl = process.env.REACT_APP_BASEURL

    const {
        modalRef,
        isSuperUser,
        isSubmitTrueOrFalse,
        dataTrueOrFalseModal,
        handleSubmitTrueOrFalse,
        handleOpenTrueOrFalseModal,
        isAdminSatkerUser
    } = useAvatar()
    return (
        <div className="dropdown">
            {/* Avatar Button */}
            <button
                className="btn p-0 border-0"
                type="button"
                id="avatarDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    overflow: "hidden",
                }}>
                {/* Avatar Image */}
                <img
                    src={`${baseUrl}/assets/img/hero-img.png`}
                    alt="Avatar"
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "1px solid grey",
                        borderRadius: "50%",
                        objectFit: "cover",
                    }}
                />
            </button>

            {/* Dropdown Menu */}
            <ul
                className="dropdown-menu dropdown-menu-start"
                aria-labelledby="avatarDropdown">
                <li>
                    <a className="dropdown-item" href="/profile">
                        Profile
                    </a>
                </li>
                {
                    !isSuperUser ? <></> :
                        <li>
                            <a className="dropdown-item" href="/admin-satker">
                                Admin Satker
                            </a>
                        </li>
                }
                {
                    !isSuperUser && !isAdminSatkerUser? <></> :
                        <li>
                            <a className="dropdown-item" href="/pegawai">
                                Pegawai / Pejabat
                            </a>
                        </li>
                }
                {
                    !isSuperUser ? <></> :
                        <li>
                            <a className="dropdown-item" href="/satker-pimpinan">
                                Satker Pimpinan
                            </a>
                        </li>
                }
                <li>
                    <hr className="dropdown-divider" />
                </li>
                <li>
                    <button className="dropdown-item" onClick={() => handleOpenTrueOrFalseModal()}>
                        Logout
                    </button>
                </li>
            </ul>
            <TrueOrFalseModal modalRef={modalRef} handleSubmit={handleSubmitTrueOrFalse} isSubmit={isSubmitTrueOrFalse} modalTitle={dataTrueOrFalseModal.title} modalDesc={dataTrueOrFalseModal.description} />
        </div>
    );
};

export default AvatarDropdown;
